import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './State';

export const AgreementCheckBoxReducer = createSlice({
  name: 'agreementCheckboxes',
  initialState,
  reducers: {
    donorAgreementAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.donorAgreement = action.payload;
    },
    authorizationForDisclosureAgreementAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.authorizationForDisclosureAgreement = action.payload;
    },
    assignmentOfBenefitAgreementAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.assignmentOfBenefitAgreement = action.payload;
    },
  }
});

export const { donorAgreementAction, authorizationForDisclosureAgreementAction, assignmentOfBenefitAgreementAction } = AgreementCheckBoxReducer.actions;
